import {IValueObject} from "@kta20-ui-base/comps/interfaces/i-value-object";
import {IItemSwipe} from "@kta20-ui-base/comps/interfaces/i-item-swipe";

const OBJ_TYPE = 'object';
const FIELD_NAME = 'fieldName';

export class DefaultListItemAdapter implements IItemSwipe {

    private readonly headerGetter:(item:any)=>any;
    private readonly titleGetter:(item:any)=>any;
    private readonly textGetter:(item:any)=>any;
    private readonly extraGetter:(item:any)=>any;

    constructor(
        private _isSwipeLeftEnabled:(item:any)=> boolean,
        private _isSwipeRightEnabled:(item:any)=> boolean,
        public headerProp:string | { fieldName:string },
        public titleProp:string | { fieldName:string },
        public textProp:string | { fieldName:string },
        public extraProp:string | { fieldName:string } = null, //optional field
    ) {
        this.headerGetter = (typeof headerProp === OBJ_TYPE) ?
            (item:any) => {
                return (<IValueObject>item[headerProp[FIELD_NAME]]).getLabel();
            }
            :
            (item:any) => {
                return item[<string>headerProp];
            };

        this.titleGetter = (typeof titleProp === OBJ_TYPE) ?
            (item:any) => {
                return (<IValueObject>item[titleProp[FIELD_NAME]]).getLabel();
            }
            :
            (item:any) => {
                return item[<string>titleProp];
            };

        this.textGetter = (typeof textProp === OBJ_TYPE) ?
            (item:any) => {
                return (<IValueObject>item[textProp[FIELD_NAME]]).getLabel();
            }
            :
            (item:any) => {
                return item[<string>textProp];
            };

        this.extraGetter = extraProp ? ((typeof extraProp === OBJ_TYPE) ?
                (item:any) => {
                    return (<IValueObject>item[extraProp[FIELD_NAME]]).getLabel();
                }
                :(item:any) => {
                    return item[<string>extraProp];
                })
            : ()=>{return ''} //when optional doesn't show anything
    }

    isSwipeLeftEnabled(item: any): boolean {
        return  this._isSwipeLeftEnabled(item);
    }

    isSwipeRightEnabled(item: any): boolean {
        return this._isSwipeRightEnabled(item);
    }

    getHeader(item:any):any{
        return this.headerGetter(item);
    }
    getTitle(item:any):any{
        return this.titleGetter(item);
    }
    getText(item:any):any{
        return this.textGetter(item);
    }
    getExtra(item:any):any{
        return this.extraGetter(item);
    }
}